/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./view-loader.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./view-loader.component";
import * as i3 from "../../view.service";
import * as i4 from "@ngxs/store";
var styles_ViewLoaderComponent = [i0.styles];
var RenderType_ViewLoaderComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_ViewLoaderComponent, data: {} });
export { RenderType_ViewLoaderComponent as RenderType_ViewLoaderComponent };
export function View_ViewLoaderComponent_0(_l) { return i1.ɵvid(2, [i1.ɵqud(402653184, 1, { viewLoaderRef: 0 }), (_l()(), i1.ɵeld(1, 0, [[1, 0], ["viewLoader", 1]], null, 1, "div", [["class", "view-loader"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.handleClick() !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), i1.ɵncd(null, 0)], null, null); }
export function View_ViewLoaderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-view-loader", [], null, null, null, View_ViewLoaderComponent_0, RenderType_ViewLoaderComponent)), i1.ɵdid(1, 180224, null, 0, i2.ViewLoaderComponent, [i1.Renderer2, i3.ViewService, i4.Actions], null, null)], null, null); }
var ViewLoaderComponentNgFactory = i1.ɵccf("app-view-loader", i2.ViewLoaderComponent, View_ViewLoaderComponent_Host_0, {}, {}, ["*"]);
export { ViewLoaderComponentNgFactory as ViewLoaderComponentNgFactory };
